<template>
    <Breadcrumbs main="Setting" mains="Permission" title="Permission" />
    <div class="container-fluid default-dashboard">
        <div class="row">
            <div class="col-sm-12">
                <div class="card">
                    <div class="card-header">
                        <div class="d-flex justify-content-between align-items-center">
                            <h5>Role Permission</h5>
                        </div>
                    </div>
                    <div class="card-body">
                        <!-- Role Selection -->
                        <div class="row mb-4">
                            <div class="col-md-4">
                                <label class="form-label col-form-label">Select Role</label>
                                <select class="form-select" v-model="selectedRole" @change="fetchPermissions">
                                    <option value="">Choose Role</option>
                                    <option v-for="role in roles" :key="role.id" :value="role.id">
                                        {{ role.name }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <!-- Search input -->
                        <div class="row mb-2">
                            <div class="col-md-6">
                                <div class="input-group">
                                    <input 
                                        type="text" 
                                        class="form-control" 
                                        placeholder="Search menu..." 
                                        v-model="searchQuery"
                                        @input="handleSearch"
                                    >
                                    <button class="btn btn-outline-secondary">
                                        <i class="fa fa-search"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- Permissions Table -->
                        <!-- Update the table structure -->
                        <div class="table-responsive">
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th style="width: 5%">No</th>
                                        <th style="width: 45%">Menu</th>
                                        <th class="text-center" style="width: 12.5%">View</th>
                                        <th class="text-center" style="width: 12.5%">Create</th>
                                        <th class="text-center" style="width: 12.5%">Edit</th>
                                        <th class="text-center" style="width: 12.5%">Delete</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="loading">
                                        <td colspan="6" class="text-center">Loading...</td>
                                    </tr>
                                    <tr v-else-if="paginatedMenus.length === 0">
                                        <td colspan="6" class="text-center">No menus found</td>
                                    </tr>
                                    <template v-else v-for="(menu, index) in paginatedMenus" :key="menu.id">
                                        <!-- Parent Menu Row -->
                                        <tr :class="{'table-light': menu.children?.length}">
                                            <td>{{ (currentPage - 1) * pageSize + index + 1 }}</td>
                                            <td>
                                                <div class="d-flex align-items-center">
                                                    <i 
                                                        v-if="menu.children?.length" 
                                                        class="fa fa-chevron-right me-2"
                                                        :class="{'fa-rotate-90': menu.expanded}"
                                                        style="cursor: pointer"
                                                        @click="toggleMenu(menu)"
                                                    ></i>
                                                    <span :style="menu.children?.length ? 'font-weight: 600' : ''">{{ menu.name }}</span>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <div v-if="!menu.children?.length" class="form-check d-flex justify-content-center">
                                                    <input 
                                                        type="checkbox" 
                                                        class="form-check-input" 
                                                        v-model="menu.permissions.view"
                                                        @change="updatePermission(menu)"
                                                    >
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <div v-if="!menu.children?.length" class="form-check d-flex justify-content-center">
                                                    <input 
                                                        type="checkbox" 
                                                        class="form-check-input" 
                                                        v-model="menu.permissions.create"
                                                        @change="updatePermission(menu)"
                                                    >
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <div v-if="!menu.children?.length" class="form-check d-flex justify-content-center">
                                                    <input 
                                                        type="checkbox" 
                                                        class="form-check-input" 
                                                        v-model="menu.permissions.edit"
                                                        @change="updatePermission(menu)"
                                                    >
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <div v-if="!menu.children?.length" class="form-check d-flex justify-content-center">
                                                    <input 
                                                        type="checkbox" 
                                                        class="form-check-input" 
                                                        v-model="menu.permissions.delete"
                                                        @change="updatePermission(menu)"
                                                    >
                                                </div>
                                            </td>
                                        </tr>
                                        <!-- Child Menu Rows -->
                                        <template v-if="menu.children?.length && menu.expanded">
                                            <tr v-for="child in menu.children" :key="child.id">
                                                <td></td>
                                                <td>
                                                    <div class="ps-4">{{ child.name }}</div>
                                                </td>
                                                <td class="text-center">
                                                    <div class="form-check d-flex justify-content-center">
                                                        <input 
                                                            type="checkbox" 
                                                            class="form-check-input" 
                                                            v-model="child.permissions.view"
                                                            @change="updatePermission(child, menu)"
                                                        >
                                                    </div>
                                                </td>
                                                <td class="text-center">
                                                    <div class="form-check d-flex justify-content-center">
                                                        <input 
                                                            type="checkbox" 
                                                            class="form-check-input" 
                                                            v-model="child.permissions.create"
                                                            @change="updatePermission(child, menu)"
                                                        >
                                                    </div>
                                                </td>
                                                <td class="text-center">
                                                    <div class="form-check d-flex justify-content-center">
                                                        <input 
                                                            type="checkbox" 
                                                            class="form-check-input" 
                                                            v-model="child.permissions.edit"
                                                            @change="updatePermission(child, menu)"
                                                        >
                                                    </div>
                                                </td>
                                                <td class="text-center">
                                                    <div class="form-check d-flex justify-content-center">
                                                        <input 
                                                            type="checkbox" 
                                                            class="form-check-input" 
                                                            v-model="child.permissions.delete"
                                                            @change="updatePermission(child, menu)"
                                                        >
                                                    </div>
                                                </td>
                                            </tr>
                                        </template>
                                    </template>
                                </tbody>
                            </table>
                        </div>

                        <!-- Pagination and Row Size Selector -->
                        <div class="d-flex justify-content-between align-items-center mt-3">
                            <div class="d-flex align-items-center">
                                <span class="me-2">Show</span>
                                <select class="form-select form-select-sm" style="width: 70px" v-model="pageSize">
                                    <option v-for="size in pageSizes" :key="size" :value="size">{{ size }}</option>
                                </select>
                                <span class="ms-2">entries</span>
                            </div>
                            <div>
                                <span>Showing {{ paginatedMenus.length ? (currentPage - 1) * pageSize + 1 : 0 }} to {{ Math.min(currentPage * pageSize, filteredMenus.length) }} of {{ filteredMenus.length }} entries</span>
                            </div>
                            <nav aria-label="Page navigation">
                                <ul class="pagination mb-0">
                                    <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                        <a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">Previous</a>
                                    </li>
                                    <li 
                                        v-for="page in totalPages" 
                                        :key="page" 
                                        class="page-item"
                                        :class="{ active: page === currentPage }"
                                    >
                                        <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
                                    </li>
                                    <li class="page-item" :class="{ disabled: currentPage === totalPages || totalPages === 0 }">
                                        <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">Next</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ref, computed, watch } from 'vue'

interface Permission {
    view: boolean;
    create: boolean;
    edit: boolean;
    delete: boolean;
}

interface Menu {
    id: number;
    name: string;
    permissions: Permission;
    children?: Menu[];
    expanded?: boolean;
}

interface Role {
    id: number;
    name: string;
}

// State
const selectedRole = ref('');
const menus = ref<Menu[]>([]);
const loading = ref(false);
const searchQuery = ref('');
const currentPage = ref(1);
const pageSize = ref(10);
const pageSizes = [5, 10, 25, 50, 100];

// Mock roles data
const roles = ref<Role[]>([
    { id: 1, name: 'Admin' },
    { id: 2, name: 'Manager' },
    { id: 3, name: 'User' }
]);

// Computed properties
const filteredMenus = computed(() => {
    if (!searchQuery.value) return menus.value;
    const query = searchQuery.value.toLowerCase();
    return menus.value.filter(menu => 
        menu.name.toLowerCase().includes(query)
    );
});

const totalPages = computed(() => {
    return Math.ceil(filteredMenus.value.length / pageSize.value) || 1;
});

const paginatedMenus = computed(() => {
    const startIndex = (currentPage.value - 1) * pageSize.value;
    const endIndex = startIndex + pageSize.value;
    return filteredMenus.value.slice(startIndex, endIndex);
});

// Watchers
watch(filteredMenus, () => {
    if (currentPage.value > totalPages.value) {
        currentPage.value = 1;
    }
});

watch(pageSize, () => {
    currentPage.value = 1;
});

// Methods
// Update the mock data in fetchPermissions
const fetchPermissions = async () => {
    if (!selectedRole.value) {
        menus.value = [];
        return;
    }

    loading.value = true;
    try {
        // Mock API call
        setTimeout(() => {
            menus.value = [
                {
                    id: 1,
                    name: 'Dashboard',
                    permissions: { view: true, create: false, edit: false, delete: false },
                    children: []
                },
                {
                    id: 2,
                    name: 'User Management',
                    permissions: { view: true, create: true, edit: true, delete: true },
                    expanded: false,
                    children: [
                        {
                            id: 21,
                            name: 'Users',
                            permissions: { view: true, create: true, edit: true, delete: true }
                        },
                        {
                            id: 22,
                            name: 'Roles',
                            permissions: { view: true, create: true, edit: true, delete: false }
                        }
                    ]
                },
                {
                    id: 3,
                    name: 'Settings',
                    permissions: { view: true, create: false, edit: true, delete: false },
                    expanded: false,
                    children: [
                        {
                            id: 31,
                            name: 'General Settings',
                            permissions: { view: true, create: false, edit: true, delete: false }
                        },
                        {
                            id: 32,
                            name: 'Email Settings',
                            permissions: { view: true, create: false, edit: true, delete: false }
                        }
                    ]
                }
            ];
            loading.value = false;
        }, 500);
    } catch (error) {
        console.error('Error fetching permissions:', error);
        loading.value = false;
    }
};

// Add toggle menu method
const toggleMenu = (menu: Menu) => {
    menu.expanded = !menu.expanded;
};

// Update permission method to handle parent-child relationship
const updatePermission = async (menu: Menu, parent?: Menu) => {
    try {
        // Replace with actual API call
        console.log('Updating permissions for:', {
            roleId: selectedRole.value,
            menuId: menu.id,
            parentId: parent?.id,
            permissions: menu.permissions
        });
    } catch (error) {
        console.error('Error updating permissions:', error);
    }
};

const handleSearch = () => {
    currentPage.value = 1;
};

const changePage = (page: number) => {
    if (page >= 1 && page <= totalPages.value) {
        currentPage.value = page;
    }
};
</script>